export const ASYNC_FETCH = 'ITP_Destination/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ITPDESTINATION = 'ITP_Destination/ASYNC_FETCH_SUCCESS_ITPDESTINATION';
export const ASYNC_FETCH_FAILURE = 'ITP_Destination/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_Destination/ASYNC_FETCH_INVALIDATE';
export const SET_SELECTED_DEST_LIST = 'ITP_Destination/SET_SELECTED_DEST_LIST';
/**
 * action types
 * @type {string}
 */
